import { IErrorLog } from '../config/error-log';
import { Util } from '../config/utils';

declare const process: any;

export interface ILogModel {
    uri?: string;
    formId?: string;
    portalId?: string;
}

export class Provider {

    userLocation: any;
    private isLogging = process.env.ISLOGGING;


    submit(uri: string, data: any) {
        return fetch(uri, {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            credentials: 'omit',
            body: JSON.stringify(data)
        })
            .then(async response => {
                if (!response.ok) {
                    return Promise.reject(await response.json());
                }
                return response.json().catch(() => Promise.resolve({}));
            })
            .catch(err => {
                if(this.isLogging){
                    this.logError(err, {uri});
                }

                return Promise.reject(err);
            });
    }

    fetch(uri: string): Promise<any> {
        return fetch(uri, {
            credentials: 'omit'
        })
            .then(response => {

                if (!response.ok) {
                    return Promise.reject(response);
                }

                return response.json();
            })
            .catch((err: string | Response | Error) => {
                if(this.isLogging){
                    this.logError(err, {uri});
                }

                return Promise.reject(err);
            });
    }

    logError(error: string | Response | Error, model: ILogModel){
        if(!this.isLogging){
            return;
        }

        const formId = model.uri ? this.getParameterByName('form', model.uri) : model.formId;
        const portalId = model.uri ? this.getParameterByName('portal', model.uri) || this.getParameterByName('portalId', model.uri) 
                            : model.portalId;

        if(!this.userLocation){
            return Util.getCountryCode().then(location =>
               this.sendErrorLog({
                    ip_address: location.ip || '',
                    country_code: location.country_code || '',
                    form_id: formId || '',
                    portal: portalId || '',
                    url: document.location ? document.location.href : '',
                    error: `Fetch Url: ${model.uri || 'N/A'}. Error: ` + (error instanceof Response ? error.statusText :
                        error instanceof Error ? error.message : error),
                    browser : navigator.userAgent
    
                })
            );
        }

            this.sendErrorLog({
                ip_address: this.userLocation.ip || '',
                country_code: this.userLocation.country_code || '',
                form_id: formId || '',
                portal: portalId || '',
                url: document.location ? document.location.href : '',
                error: `Fetch Url: ${model.uri || 'N/A'}. Error: ` + (error instanceof Response ? error.statusText :
                        error instanceof Error ? error.message : error),
                browser : navigator.userAgent

            });
    }

    sendErrorLog(data: IErrorLog) {
        const host = process.env.API_URL;

        if(!data.portal){
            return;
        }
        return this.submit(`${host}pub/events/${data.portal}/js_log`, data);
    }

    getGeoIp(): Promise<any> {
        if(this.userLocation){
            return Promise.resolve(this.userLocation);
        }

        return this.fetch(`https://json.geoiplookup.io/?key=7ac8f89c81d04a411357e2f50ef4be17`)
            .then(response => {
                this.userLocation = response;
                return response;
            });
    }

    getParameterByName(name: string, url: string) {
        if (!url) {
             url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);

        if (!results) {
             return null;
            }
        if (!results[2]) {
             return '';
            }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}
